<template>
  <div
    class="flex gap-12"
    :class="{
      'items-center': isLoading,
    }"
  >
    <div>
      <RevSkeleton v-if="isLoading" height="24px" shape="circle" width="24px" />
      <component :is="icon" v-else class="shrink-0" size="24" />
    </div>

    <div class="body-2 w-full">
      <RevSkeleton v-if="isLoading" height="12px" shape="line" width="100%" />
      <slot v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { RevSkeleton } from '@ds/components/Skeleton'

defineProps<{
  icon: Component
  isLoading?: boolean
}>()
</script>
